import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { ChartMode } from "../Dimensions/DimensionTreeSwitch";
import { ComparisonChart } from "./Comparison/ComparisonChart";
import { DistributionChart } from "./Distribution/DistributionChart";
import { EvolutionChart2 } from "./EvolutionChart";
import { DimensionValue, MainScore } from "src/api/client-api/olapScores/olapScoresSchema";
import { OlapScoresParams } from "src/context/OlapScores/useOlapScoresParams";
import { ModalData } from "../PropertyModal/PropertyModal";
import { OnLastLevelClickAction } from "./Distribution/DistributionChartCore";
import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import type { ReactNode } from "react";
import type { FetchPostForAnswers } from "src/context/ScoreDetail/context";
import type { ComponentAppearance } from "src/components/appearance";

type ScoreDetailChartBoxProps = {
    scoreId: number;
    olapScores?: MainScore;
    olapPrevScores?: MainScore;
    scoresParams?: OlapScoresParams;
    areAggregationsRequested?: boolean;
    getDimensionValueLocalizedLabel?: (dimension: string, key: string | number) => string | null;
    getDimensionValuesColors?: (dimensionValues: Array<{ dimension: string; id: string | number }>) => string[];
    getDimensionValueDrilldownAction?: (
        dimension: string,
        dimensionValue: DimensionValue | undefined,
        onLastLevelClick?: OnLastLevelClickAction,
    ) => (() => void) | undefined;
    distributionContent?: ReactNode;
    mode: ChartMode;
    isLoading?: boolean;
    ssqVersion?: SsqVersion;
    fetchPostForAnswers?: FetchPostForAnswers;
    hideSeeMoreDetails?: (dimension: string) => boolean;
    openModal?: (property: ModalData) => void;
    prevCampaign?: string;
    appearance?: ComponentAppearance;
};
export const ScoreDetailChartBox = (props: ScoreDetailChartBoxProps) => {
    const { mode, appearance = "legacy" } = props;
    const { drilldownState } = useScoreDetailContext();

    if (mode === "distribution") {
        return <DistributionChart {...props} drilldownState={drilldownState} />;
    }

    if (mode === "comparison") {
        return <ComparisonChart appearance={appearance} />;
    }

    if (mode === "evolution") {
        // It's called 2 but it's not used right now
        return <EvolutionChart2 appearance={appearance} />;
    }

    // Will throw type error is ChartMode case is not handled properly
    const _d: never = mode;
};
